import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LOCALE_ID } from "@angular/core";
import { registerLocaleData } from "@angular/common";
import { InterviewDataService } from "./student/interview/services/interview-data.service";
import { GlobalService } from "./common/services/global.service";
import locale_en from '@angular/common/locales/en';
import locale_ar_sa from '@angular/common/locales/ar-SA';
import locale_es_419 from '@angular/common/locales/es-419';
import locale_fr from '@angular/common/locales/fr';
import locale_he_il from '@angular/common/locales/he';
import locale_it_it from '@angular/common/locales/it';
import locale_pt from '@angular/common/locales/pt';
import { HttpClient } from '@angular/common/http';
declare var window:any;
declare var navigator:any;

registerLocaleDataForAngular(window.LOCALE);

@Component({
    selector: 'my-app',
    templateUrl: './app.component.html',
    providers: [{ provide: LOCALE_ID, useValue: window.LOCALE }],
    standalone: false
})

export class AppComponent {

    notIE:boolean;
    usertype:any;
    interview_id:any;

    constructor(private translate: TranslateService,
                private http: HttpClient,
                private _route:ActivatedRoute,
                public globalService: GlobalService,
                private _dataService: InterviewDataService) {

        let languages = ['ar_sa', 'es_419', 'fr', 'he_il', 'it_it', 'pt_br'];

        if (languages.indexOf(window.LANGPACK) > -1) {
            translate.setDefaultLang(window.LANGPACK);
            translate.use(window.LANGPACK);
        } else {
            translate.setDefaultLang('en');
            translate.use('en');
        }

        window.parent.CURRENT_USER = sessionStorage.getItem('current_user');
        window.parent.CURRENT_USER_NAME = sessionStorage.getItem('username');
        window.parent.USER_TYPE = sessionStorage.getItem('usertype');
        window.parent.REVIEWER_TOKEN = sessionStorage.getItem('token');
        window.parent.LOGGED_IN = sessionStorage.getItem('logged_in');
        window.parent.STUDENT_ID = sessionStorage.getItem('student_id');

        if (typeof window.parent.isWebRTCSupported === 'undefined') {
            this.checkWebRTCSupport();
        }
        this.notIE = window.parent.isWebRTCSupported;
        this.usertype = window.parent.USER_TYPE;
    }

    checkWebRTCSupport() {
        const hasWebRTC = !!(navigator.mediaDevices &&
            navigator.mediaDevices.getUserMedia &&
            window.RTCPeerConnection);

        if (!hasWebRTC) {
            window.parent.isWebRTCSupported = false;
            return;
        }

        const ua = navigator.userAgent || '';
        const isChrome = /Chrome\//.test(ua) && !/Edg\//.test(ua);
        const isEdge = /Edg\//.test(ua);
        const isChromeIOS = /CriOS\//.test(ua);
        const isEdgeIOS = /EdgiOS\//.test(ua);

        window.parent.isWebRTCSupported = isChrome || isEdge || isChromeIOS || isEdgeIOS;
    }

}

function registerLocaleDataForAngular(locale)
{
    switch (locale) {
        case 'ar_sa':
            registerLocaleData(locale_ar_sa, 'ar_sa');
            break;
        case 'es_419':
            registerLocaleData(locale_es_419, 'es_419');
            break;
        case 'fr':
            registerLocaleData(locale_fr, 'fr');
            break;
        case 'he_il':
            registerLocaleData(locale_he_il, 'he_il');
            break;
        case 'it_it':
            registerLocaleData(locale_it_it, 'it_it');
            break;
        case 'pt_br':
            registerLocaleData(locale_pt, 'pt_br');
            break;
        default:
            registerLocaleData(locale_en, locale);
            break;
    }
}
